import { ProductivityDashboardProvider } from "../../../providers/Dashboards/ProductivityDashboardProvider";
import ProductivityDashboard from "./ProductivityDashboard";

const ProductivityDashboardPage = () => {
  return (
    <ProductivityDashboardProvider>
      <ProductivityDashboard />
    </ProductivityDashboardProvider>
  );
};

export default ProductivityDashboardPage;
